import axios from 'axios';
import { environment } from '../environments/environment';
import { getPeriodMetaFactory } from '../utils/PeriodUtils';
import { applyParamsBasedOnFilterPOST } from './utils/OverviewServiceUtils';
import {
  BrandDependencyReqParam,
  BrandDependencyChartResp,
  BrandDependencyApiEndpoint,
  BrandDeepDiveChartResp,
} from '../models/BrandDependency';
import { RelativePeriod } from '../components/comparison-period-selector/Types';
import { getQueryClient } from '../queries/QueryClientWrapper';
const constructRequest = (param: BrandDependencyReqParam) => {
  //Future implementation of Custom Periods in Trading Assistant page, will need to remove this assignment
  const comparisonPeriod = param.comparisonPeriod as RelativePeriod;
  const periodMetaForTA = getPeriodMetaFactory(param.period, comparisonPeriod, param.periodType);

  return {
    ...param,
    country: param.countries.map((ctry) => ctry?.id),
    productGroup: param.productGroup.map((pg) => pg.value),
    periodType: param.periodType ? param.periodType.toUpperCase().replace(/\s/g, '') : '',
    period: periodMetaForTA?.currentPeriod.toUpperCase() ?? '',
    comparisonPeriod: periodMetaForTA?.comparisonPeriod.toUpperCase() ?? '',
    appliedFilters: undefined,
  };
};

const sendBrandDependencyRequest = async <T>(
  apiEndpoint: BrandDependencyApiEndpoint,
  param: BrandDependencyReqParam,
) => {
  const qc = getQueryClient('trading-assistant');
  try {
    return await qc.ensureQueryData({
      queryKey: [
        'trading-assistant-brand-dependency-chart',
        apiEndpoint,
        param.period,
        param.comparisonPeriod,
        param.appliedFilters,
        param.segmentBy,
        param.segmentByDataType,
      ],
      queryFn: async ({ signal }) => {
        const params = constructRequest(param);
        applyParamsBasedOnFilterPOST(params, param.appliedFilters);

        const { data } = await axios.post<T>(`${environment.baseUrl}/v2/trading-assistant/${apiEndpoint}`, params, {
          signal: signal,
        });

        return data;
      },
      retry: false,
    });
  } catch (err: any) {
    if (axios.isCancel(err)) {
      console.warn('Request to /brand-dependency-chart has been cancelled.');
      return undefined;
    } else {
      throw new Error(`An error has occurred: ${err.message}`);
    }
  }
};

export const getBrandDependency = async (param: BrandDependencyReqParam) =>
  sendBrandDependencyRequest<BrandDependencyChartResp>('brand-dependency-chart', param);

export const getBrandDeepDive = async (param: BrandDependencyReqParam) =>
  sendBrandDependencyRequest<BrandDeepDiveChartResp>('brand-deep-dive', param);
